module.exports = __webpack_public_path__ + "img/typhoon_32.a4b0f2d6.jpg";